import { render, staticRenderFns } from "./iconDocumentCopy.vue?vue&type=template&id=da204b42&"
import script from "./iconDocumentCopy.vue?vue&type=script&lang=js&"
export * from "./iconDocumentCopy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('da204b42')) {
      api.createRecord('da204b42', component.options)
    } else {
      api.reload('da204b42', component.options)
    }
    module.hot.accept("./iconDocumentCopy.vue?vue&type=template&id=da204b42&", function () {
      api.rerender('da204b42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/grid/iconDocumentCopy.vue"
export default component.exports